<template>
  <div class="container ">
    <div class="content">

      <div class="card">
        <span class="">Product Gallery</span>
        <div class="grid grid-cols-3 gap-3 mt-3">
          <ProductItem
              show-name
              v-for="(item,index) in myProducts"
              :key="index"
              :selected="item.selected"
              :product-info="item"
              @onSelectProduct="onSelectProduct(item,index)"/>
        </div>
      </div>
    </div>


    <PopupBrandInfo v-model="showBrandPopup"
        :is-add="isAddBrand"
        :button-text="submitText"/>

    <CustomizationBottomOperate :disabled="disableEdit" text="Create" @onBrandEdit="onBrandEdit" @onNext="onNext"/>
  </div>
</template>

<script>
import produce from "@/api/produce";
import CustomizationBottomOperate from "@/components/customization/CustomizationBottomOperate.vue";
import log from "@/util/log";
import bus from "@/util/EventBus";
import PopupBrandInfo from "@/components/customization/PopupBrandInfo.vue";
import ProductItem from "@/components/customization/ProductItem.vue";
import BrandItem from "@/components/customization/BrandItem.vue";

export default {
  name: "Product",
  components: { BrandItem, ProductItem, PopupBrandInfo, CustomizationBottomOperate },
  props: {},
  data() {
    return {
      myProducts: null,
      currentSelected: -1,
      showBrandPopup: false,
      isAddBrand: false,
      submitText: "Submit"
    };
  },
  methods: {
    async loadData() {
      const myProducts = await produce.myProducts();
      myProducts.forEach((item) => {
        item.selected = false;
      });
      this.myProducts = myProducts;
    },
    onSelectProduct(item, index) {
      const myProducts = this.myProducts;
      if (this.currentSelected !== -1) {
        myProducts[this.currentSelected].selected = false;
      }
      myProducts[index].selected = true;
      this.currentSelected = index;
    },
    onAddBrand() {
      if (this.currentSelected !== -1) {
        this.myBrands[this.currentSelected].selected = false;
      }
      this.currentSelected = -1;
      this.submitText = "Apply";
      this.isAddBrand = true;
      this.showBrandPopup = true;
    },
    onBrandEdit() {
      this.isAddBrand = false;
      log("onBrandEdit");
      this.submitText = "Submit";
      this.showBrandPopup = true;
    },
    onNext() {
      log("onNext");
      localStorage.removeItem('selectProductId')
      this.$router.push({
        path: '/customization/flavor',
        query :{
          brandId: this.$route.query.brandId,
          productId:this.myProducts[this.currentSelected].id,
        }
      })
    },
    onUpdateBrandInfo(brandInfo) {
      const index = this.myBrands.findIndex(item => item.id === brandInfo.id);
      if (index === -1) {
        return;
      }

      log(`Update brand info ${JSON.stringify(brandInfo)}`);
      this.myBrands[index] = brandInfo;
    },
    async onUpdateBrandList() {
      await this.loadData();
    }

  },
  computed: {
    disableEdit() {
      return this.currentSelected === -1 ;
    }
  },
  async mounted() {
    setTimeout(() => {
      bus.$emit("stepChange", 1);
    });
    await this.loadData();
  }
};
</script>


<style scoped lang="less">

.content {
  height: 100%;
  padding-bottom: calc(70px + env(safe-area-inset-bottom) + 16px);
  overflow-y: auto;
  background: #f6f6f6;
}

</style>